import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import theme from '@styles/theme';

import { FlexBox } from '@components/styled/StyledComponents';

type TabMenuProps = {
    setSelectedTab: Dispatch<SetStateAction<string>>;
    selectedTab: string;
    options: string[];
    margin?: string;
};
const TabMenu = ({
    selectedTab,
    setSelectedTab,
    options,
    margin = '0'
}: TabMenuProps) => {
    return (
        <FlexBox $margin={margin}>
            {options.map((option, index) => (
                <Wrapper key={`${index}-${option}`}>
                    <Input
                        type="radio"
                        id={`${index}-filter`}
                        name="filter"
                        value={option}
                        onChange={(e) => setSelectedTab(e.target.value)}
                        checked={option === selectedTab}
                    />
                    <Label htmlFor={`${index}-filter`}>{option}</Label>
                </Wrapper>
            ))}
        </FlexBox>
    );
};

export default TabMenu;

const Wrapper = styled.div``;

const Label = styled.label`
    display: inline-block;
    padding: 10px 0;
    width: 140px;
    font-size: 18px;
    text-align: center;
    font-family: PretendardMedium, sans-serif;
    border-bottom: ${theme.colors.whiteColor} 2px solid;
    transition: all 0.25s;
    cursor: pointer;
`;

const Input = styled.input`
    display: none;
    &:checked ~ label {
        font-family: PretendardSemibold, sans-serif;
        color: ${theme.colors.positiveBlue};
        border-bottom: ${theme.colors.positiveBlue} 2px solid;
    }
`;
